<template>
	<Modal v-model="showModal"  title="选择款式"  width="1200"  @on-cancel="cancel"  @on-ok="submit" :styles="{top: '100px'}">
        
        <div class="list">
            <div class="item" v-for="(v, k) in design_list" :key="`d` + k" :class="v.checked?'active':''" @click.stop="selectOn(v)">
                <div class="left">
                    <img :src="v.image | default_img" alt="" class="image">
                </div>
                <div class="right">
                    <div class="name-wrap">
                        <div class="name">{{ v.name }}</div>
                        <div class="status" :class="oc(v)">{{ v.status_name }}</div>
                    </div>
                    <div class="style_no"><span>款号</span>：{{ v.style_no }}</div>
                    <div class="category"><span>款式分类</span>：{{ v.product_category_name }}</div>
                    <div class="step" v-if="v.status >= 3">
                        设计报价：{{ v.factory_price }}元
                    </div>
                    <div class="desc"><span>款式说明</span>：{{ v.description }}</div>
                    <div class="time">创建时间：{{ v.update_time }}</div>
                    <div class="btn-group">
                        <div class="btn btn-design">选择款式</div>
                    </div>
                </div>
            </div>
        </div>
        
	</Modal>
</template>

<script>

	import {
		DesignList,
	} from "@/api/index.js"
	export default {
		name: "SelectDesign",
		props: {
			
		},
		data() {
			return {
				showModal: false,
				design_list:[]
			};
		},
		watch: {
			
			
		},
		methods: {
            show() {
                this.getDesignList()
                this.showModal = true
            },
            oc(v) {
				return [v.status_text]
			},
            selectOn(v) {
                this.$set(v,'checked',!v.checked)
            },
            async getDesignList() {
				this.design_list = [];
				return DesignList(this.form_data).then(response => {
					this.design_list = response.data;
				})
			},
			cancel() {
				this.$emit("cancel");
			},
			submit() {
				let list = this.design_list.filter((i)=>{
                    return i.checked
                })
                this.$emit('select-design',list)
			}
		},
		mounted() {

		},
	};
</script>

<style lang="scss" scoped>
	

.list {
    padding: 10px 0 50px 0;
    display: flex;
    align-items: center;
    column-gap:20px;
    row-gap:20px;
    flex-wrap: wrap;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 60vh;

    .item {
        display: flex;
        flex-wrap: nowrap;
        flex:0 1 48%;
        height: 270px;
        background: #FFFFFF;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #EBEDF2;
        cursor: pointer;
        &.active{
            border: 1px solid #FA3D5A;
        }
        .left {
            width: 240px;
            // height: 240px;
            height:100%;
            .image {
                border:1px solid #ebedf2;
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 10px 0 0 10px;
            }
        }
        .right {
            margin: 0 20px;
            text-align: left;
            flex:1;
            .name-wrap{
                height: 53px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #EBEDF2;
                .name {
                    font-size: 18px;
                    color: #333333;
                    font-weight: bold;
                }
                .status {
                    width: 70px;
                    height: 25px;
                    line-height: 25px;
                    border-radius: 5px 0px 5px 0px;
                    text-align: center;
                    font-family: "Microsoft YaHei";
                    &.draft {
                        color: #30C6D0;
                        border: 1px solid #30C6D0;
                    }
                    &.bargain {
                        color: #FF9000;
                        border: 1px solid #FF9000;
                    }
                    &.confirm_design {
                        color: #E72C28;
                        border: 1px solid #E72C28;
                    }
                }
            }

            .style_no, .category, .desc {
                margin: 6px 0;
                color: #707070;
                font-size: 14px;
            }
            .desc {
                height: 40px;
                overflow-y: hidden;
            }

            span {
                color: #4D4D4D;
                font-size: 14px;
            }

            .time {
                margin: 5px 0;
                font-size: 12px;
                color: #808080;
                text-overflow:ellipsis;
                overflow:hidden;
                white-space:nowrap;
            }

            .btn-group {
                margin-top: 23px;
                display: flex;
                justify-content: flex-end;
                .btn {
                    width: 80px;
                    height: 35px;
                    line-height: 35px;
                    text-align: center;
                    border-radius: 5px;
                    font-size: 16px;
                    margin: 0 5px;
                    &.btn-del {
                        border: 1px solid #D0D2D6;
                        color: #68696A;
                    }
                    &.btn-design {
                        background: #FA3D5A;
                        color: white;
                    }
                }
            }
        }



        &:nth-child(2n) {
            margin-right: 0;
        }
    }
}
</style>
